import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

// INSERT CERTIFICATE
export const insertCertificate = createAsyncThunk(
  "certificate/insertCertificate",
  async (data, { rejectWithValue }) => {
    const url = `${baseUrl}insertCertififcate`;
    try {
      const response = await axios.post(url, data);
      if (response.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// GET CERTIFICATE
export const GetCertificate = createAsyncThunk(
  "certificate/getCertificate", // <-- CHANGED
  async (data, { rejectWithValue }) => {
    const url = `${baseUrl}GetCertififcate`;
    try {
      const response = await axios.post(url, data);
      if (response.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// DELETE CERTIFICATE
export const deleteCertificate = createAsyncThunk(
  "certificate/deleteCertificate",
  async (data, { rejectWithValue }) => {
    const url = `${baseUrl}deleteCertififcate`;
    try {
      const response = await axios.post(url, data);
      if (response.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
